import { PageContent, Box, Header, Heading, Paragraph, Anchor, Image } from "grommet";
import { PropsWithChildren } from "react";
import { AppPage } from "../components/app-page";
import React from "react";
import Ladder from "../images/ladder.png";
import { CaseyImage } from "../components/casey-image";
import CabinInterior from "../images/cabin-interior.jpg";
import Camp2 from "../images/camp2.png";
import { useNavigate } from "react-router-dom";

const Event: React.FC<PropsWithChildren> = () => {
    const navigate = useNavigate();
    return (
        <AppPage>
            <>
                <PageContent overflow="hidden" background={{ fill: 'horizontal', color: 'charcoal' }}>
                    <Box align="center" direction="column" pad={{ horizontal: "xsmall", vertical: "medium" }}>
                        <Header direction="column" gap="small" overflow="hidden" className="title-medium">
                            <Heading weight="normal" margin="none" textAlign="center">WE ARE</Heading>
                            <Heading weight="normal" margin="none" textAlign="center">CAMPING</Heading>

                        </Header>
                        <div className="title-small">
                            <Box direction="row" justify="center">
                                <Heading weight="normal" color="orange" textAlign="center" margin="20px" style={{ display: "flex", alignItems: "center" }}>
                                    JUNE 3-7 2026
                                </Heading>

                            </Box>
                        </div>
                    </Box>
                </PageContent>
                <PageContent overflow="hidden" background={{ fill: 'horizontal', color: 'orange' }} pad={{ top: "30px", bottom: "30px" }}>
                    <Box direction="row" justify="center" pad="none">
                        <CaseyImage
                            fit="cover"
                            src={Ladder}
                            style={{ width: "70px" }}
                            alignSelf="center"
                            margin={{ horizontal: "medium" }}
                        />
                        <Box align="center">
                            <Heading weight="normal" color="cream_constant" textAlign="center">
                                <Anchor className="small-text title-xsmall" weight="normal" href="https://www.nps.gov/prwi/planyourvisit/group-cabin-camping.htm" target="_blank">Prince William Forest Park</Anchor>
                            </Heading>
                        </Box>
                        <CaseyImage
                            fit="cover"
                            src={Ladder}
                            style={{ width: "70px" }}
                            alignSelf="center"
                            margin={{ horizontal: "medium" }}
                        />
                    </Box>
                    <Paragraph color="cream_constant" style={{ marginBottom: "0px" }} textAlign="center">
                        <Anchor href="https://maps.app.goo.gl/kc9W2sQtVtz3m2JL7" target="_" color="charcoal"> 17175 Mawavi Rd, Triangle, VA 22172
                        </Anchor>
                    </Paragraph>

                </PageContent>
                <PageContent overflow="hidden" background={{ fill: 'horizontal', color: 'green_foreground' }}>
                    <Box align="center" pad={{ horizontal: "large", vertical: "large" }}>
                        <Heading className="small-text" weight="normal" size="50px" margin="none" color="cream" textAlign="center">the plan</Heading>
                        <Paragraph color="cream">
                            We will be renting <Anchor href="https://www.nps.gov/prwi/planyourvisit/cabincamp2.htm" target="_" color="cream">Group Cabin Camp 2</Anchor> at Prince William Forest Park! See the <Anchor href="https://www.nps.gov/media/photo/gallery.htm?pg=2812332&id=2B850EC0-1DD8-B71C-0702C9CE5CF7AE17" target="_" color="cream">photo gallery</Anchor> for a preview of the accomodations.

                            <b> The main event will be on Saturday,</b> but we will be renting out the cabin camp starting Wednesday for some extra time on the lake. Come for as long or as short a stay as you want!
                        </Paragraph>
                        <Paragraph color="cream">
                            We will have access to a lake, ballpark, hiking trails, and fire circle, so bring gear to play outside! We also have craft lodges and a dining hall for any indoor games or activites you would like to bring. Julia is planning to be floating on the lake whenever possible. Children are welcome.
                        </Paragraph>
                        <Image src={Camp2} alt="Cabin Camp 2 Map" className="cabin-image" alignSelf="center" />
                    </Box>
                </PageContent>


                <PageContent overflow="hidden" background={{ fill: 'horizontal', color: 'cream' }}>
                    <Box pad={{ horizontal: "large", vertical: "large" }}>
                        <Heading className="small-text" weight="normal" size="50px" margin="none" color="cream" textAlign="center">the vibes</Heading>
                        <Paragraph color="cream">
                            This is a <b>very casual event,</b> so expect to mostly hang out, relax, and enjoy nature with friends and family.
                            We are not going to be having a traditional wedding ceremony, but we will be celebrating the past 10 years together and getting married (assuming we figure out how).
                        </Paragraph>
                        <Paragraph color="cream">Please come if it sounds like fun to go camping with us! Do not feel any pressure to attend because of the typical formalities of a wedding.
                        </Paragraph>
                    </Box>
                </PageContent>
                <PageContent overflow="hidden" background={{ fill: 'horizontal', color: 'green_foreground' }}>
                    <Box align="center" pad={{ horizontal: "large", vertical: "large" }}>
                        <div className="video-container" >
                            <iframe title="Video Embed" src="https://www.nps.gov/media/video/embed.htm?id=6BEA4C37-A2E7-4AA7-9E34-0E6B2760439C" width="480" height="306"></iframe>
                        </div>
                    </Box>

                </PageContent>


                <PageContent overflow="hidden" background={{ fill: 'horizontal', color: 'charcoal' }}>
                    <Box align="center" pad={{ horizontal: "large", vertical: "large" }}>
                        <Heading className="small-text" weight="normal" size="50px" margin="none" color="green_foreground" textAlign="center">the details</Heading>
                        <Paragraph color="cream">
                            Please note that it will be the middle of the summer and the <strong>cabins do not have AC.</strong> However, the camp is shady and cabins have outlets for fans. We will bring extra fans for those travelling by plane.
                            If the heat/camp life is a concern for you, you are welcome to find alternate accomodations and come hang out with us during the day. The camp is right off of I-95 near Triangle and Dumfries, VA, so there should be plenty of options available.
                        </Paragraph>
                        <Paragraph color="green_foreground">
                            <ul>
                                <li>We are renting out the whole group cabin camp, so all lodging is <b>free of charge</b> if you choose to stay at camp with us.</li>
                                <li>Every vehicle will still need to purchase or show proof of a park pass ($20). Please see <Anchor color="green_foreground" onClick={() => { navigate("/travel") }}>travel</Anchor> for details.</li>
                                <li>We will be doing all the cooking and cleaning ourselves. You can <b>volunteer for a task team</b> in the RSVP form. </li>
                                <li>Meals will be simple and prepared by an assigned group of people from the cooking team in the industrial kitchen in the dining hall. If you have dietary restrictions, please let us know in the RSVP form so we can plan accordingly.</li>
                                <li>Cabins sleep 2-6 people. We will get people assigned to a cabin that works well for their needs.</li>
                                <li><b>We will need to bring our own linens.</b> Cabins are equipped with twin size cots (no bunk beds).</li>
                                <li>Bathrooms and showers are shared and located in a separate building. There are 5 different restroom buildings dispersed around the camp, so there will be something close to your cabin.</li>
                                <li>There is no A/C, but there are power outlets. <b>Bring fans!</b> We can bring extra for folks travelling by plane</li>
                                <li>Cabins are not completely sealed from bugs and small critters, but the windows have screens.</li>
                                <li>The pathways throughout camp are not lighted at night so bring flashlights/lanterns. We will have extras.</li>
                                <li>Bring your camping chairs to make rooms, craft lodges, and lakeside more comfy!</li>
                            </ul>
                        </Paragraph>
                        <Paragraph color="green_foreground">
                            This is an example of what a cabin interior looks like:
                        </Paragraph>
                        <Image src={CabinInterior} alt="Cabin Interior" className="cabin-image" alignSelf="center" />
                    </Box>

                </PageContent>

            </>
        </AppPage>
    );
}

export default Event;
